import Description from "@/partials/elements/Description";
import Headline from "@/partials/elements/Headline";
import ViewAll from "@/partials/elements/ViewAll";
import { useRouter } from "next/navigation";
import FlexSection from "../../Section/FlexSection";

export default function TeamMemberInfo() {
  const route = useRouter();
  return (
    <div className=" mx-auto">
      <FlexSection extraClass="justify-between pb-6  mx-auto">
        <Headline text={"Meet Our Team"} />
        <ViewAll text={"View All"} action={() => route.push("/team")} />
      </FlexSection>
      <Description
        text={`The need for a well co-ordinates scientific and educational association
      for all the surgeons of the country was conceptualized`}
        extraClass={"pb-8"}
      />
    </div>
  );
}
